import { all } from "@redux-saga/core/effects";

import { initialScrapeTaskBatchStartsEntriesSagas } from "modules/InitialScrapeTaskBatchStarts/services/InitialScrapeTaskBatchStarts/sagas";

export function* initialScrapeTaskBatchStartsSaga() {
    yield all([
        initialScrapeTaskBatchStartsEntriesSagas()
    ]);
}